import _ from 'lodash';

// experience status and status dates (publishDate, expiryDate, retentionDate) are reserved fields, and should not be used in dirty tracking or experience update API calls.
const reservedExperienceFields = {
  STATUS:         'status',
  PUBLISH_DATE:   'publishDate',
  RETENTION_DATE: 'retentionDate',
  EXPIRY_DATE:    'expiryDate',
  APPROVAL:       'approval',
};

reservedExperienceFields.ALL = _.values(reservedExperienceFields);

export { reservedExperienceFields };
